import VariableContainer from './variable_container';

const Variable = VariableContainer;
export default Variable;
